import { createEvent, createStore } from 'effector'

export const actions = {
  setSite: createEvent<SiteResponse>('setSite'),
  resetSite: createEvent('resetSite'),

  setSiteStats: createEvent<IncidentsStatistiquesResponse>('setSiteStats'),
  resetSiteStats: createEvent('resetSiteStats'),

  setManifestations: createEvent<OrderedManifestations>('setManifestations'),
  resetManifestations: createEvent('resetManifestations'),

  setManifestation: createEvent<ManifestationResponse>('setManifestation'),
  resetManifestation: createEvent('resetManifestation'),

  setTenants: createEvent<OrderedTenants>('setTenants'),
  resetTenants: createEvent('resetTenants'),

  reset: createEvent('reset'),

  setSites: createEvent<SiteResponse[]>('setSites'),
}

const initialState: SiteState = {
  site: undefined,
  siteStats: undefined,
  sites: [],
  manifestation: undefined,
  tenants: { current: [], incoming: [], former: [] },
  manifestations: { inProgress: [], incoming: [], toBeClosed: [] },
}

export const store = createStore<SiteState>(initialState, { name: 'site' })
  .on(actions.setSite, (s, site) => ({ ...s, site }))
  .on(actions.setSiteStats, (s, siteStats) => ({ ...s, siteStats }))
  .on(actions.setManifestations, (s, manifestations) => ({ ...s, manifestations }))
  .on(actions.setTenants, (s, tenants) => ({ ...s, tenants }))
  .on(actions.setSites, (s, sites) => ({ ...s, sites }))
  .on(actions.setManifestation, (s, manifestation) => ({ ...s, manifestation }))
  .on(actions.resetSite, (s) => ({ ...s, site: initialState.site }))
  .on(actions.resetSiteStats, (s) => ({ ...s, siteStats: initialState.siteStats }))
  .on(actions.resetTenants, (s) => ({ ...s, tenants: initialState.tenants }))
  .on(actions.resetManifestations, (s) => ({ ...s, manifestations: initialState.manifestations }))
  .on(actions.resetManifestation, (s) => ({ ...s, manifestation: initialState.manifestation }))
  .on(actions.reset, () => ({ ...initialState }))
